import React from 'react';
import {
  BatteryCharging,
  BatteryCost,
  BatteryDestination,
  Business,
  BusinessCustomersPrivate,
  Charging,
  ChargingStation,
  Checkmark,
  City,
  CountryRoad,
  Discount,
  Download,
  Eco,
  Edit,
  ElectricCars,
  Electricity,
  HighwayRoad,
  Home,
  Info,
  Reload,
  Size,
  Wallbox,
} from '@volkswagen-onehub/icons-core';
import {IconProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {ExternalLinkIndicator} from '@volkswagen-onehub/components-core';
import {TextInverted} from '../text';
import styled from 'styled-components';

export function Icon(props: IconProps): JSX.Element {
  return IconSymbol(props);
}

export function IconInverted(props: IconProps): JSX.Element {
  return (
    <IconInvertedWrapper>
      <TextInverted variant={'copy'}>{IconSymbol(props)}</TextInverted>
    </IconInvertedWrapper>
  );
}

export function IconSymbol({name, size, ...rest}: IconProps): JSX.Element {
  const variantSmallOrDefault = size === 'small' ? 'small' : 'default';
  const allVariants =
    size === 'small' ? 'small' : size === 'large' ? 'large' : 'default';

  switch (name) {
    case 'BatteryCharging':
      return <BatteryCharging variant={'large'} {...rest} />;
    case 'BatteryCost':
      return <BatteryCost variant={'large'} {...rest} />;
    case 'BatteryDestination':
      return <BatteryDestination variant={'large'} {...rest} />;
    case 'Charging':
      return <Charging variant={allVariants} {...rest} />;
    case 'ChargingSocket':
      return <Charging variant={allVariants} {...rest} />;
    case 'ChargingStation':
      return <ChargingStation variant={variantSmallOrDefault} {...rest} />;
    case 'ChargingWallbox':
      return <Wallbox variant={variantSmallOrDefault} {...rest} />;
    case 'Checkmark':
      return <Checkmark variant={variantSmallOrDefault} {...rest} />;
    case 'Discount':
      return <Discount variant={variantSmallOrDefault} {...rest} />;
    case 'Download':
      return <Download variant={variantSmallOrDefault} {...rest} />;
    case 'Eco':
      return <Eco variant={allVariants} {...rest} />;
    case 'Edit':
      return <Edit variant={variantSmallOrDefault} {...rest} />;
    case 'ElectricCars':
      return <ElectricCars />;
    case 'Electricity':
      return <Electricity variant={variantSmallOrDefault} {...rest} />;
    case 'ExternalLink':
      return <ExternalLinkIndicator />;
    case 'Info':
      return <Info variant={variantSmallOrDefault} {...rest} />;
    case 'LocationCountryRoad':
      return <CountryRoad variant={variantSmallOrDefault} {...rest} />;
    case 'LocationHighway':
      return <HighwayRoad variant={variantSmallOrDefault} {...rest} />;
    case 'LocationHome':
      return <Home variant={variantSmallOrDefault} {...rest} />;
    case 'LocationPublic':
      return <City variant={variantSmallOrDefault} {...rest} />;
    case 'LocationWork':
      return size === 'small' ? (
        <Business variant={'small'} {...rest} />
      ) : (
        <BusinessCustomersPrivate {...rest} />
      );
    case 'Reload':
      return <Reload variant={variantSmallOrDefault} {...rest} />;
    case 'Size':
      return <Size variant={variantSmallOrDefault} {...rest} />;
  }
}

const IconInvertedWrapper = styled.div`
  & > div {
    margin: 0;
  }
`;
